import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { InsuranceModule, InsuranceModules } from '@zinnia/form-engine-sdk';

import { EditorDropdown } from './EditorDropdown';

type Props = {
  onChange: (updatedSelection: InsuranceModule) => void;
  selectedModule: InsuranceModule;
  disabled?: boolean;
};

export function ModuleSelection({ selectedModule, onChange, disabled }: Props): ReactElement {
  const { t } = useTranslation();

  return (
    <EditorDropdown
      id='addFieldFieldTypeDropdown'
      label={t('admin.questionnaireManagement.module.title')}
      selectedOptionValue={selectedModule}
      onChange={(newValue) => onChange(newValue as InsuranceModule)}
      disabled={disabled}
      options={[
        {
          value: InsuranceModules.insuranceApplication,
          label: t('admin.questionnaireManagement.module.insuranceApplication'),
        },
        {
          value: InsuranceModules.needsAnalysis,
          label: t('admin.questionnaireManagement.module.needsAnalysis'),
        },
      ]}
    />
  );
}
